import { MatPaginatorIntl } from '@angular/material';

export function CustomPaginator() {
    var lang = localStorage.getItem('selectedLanguage');
    const customPaginatorIntl = new MatPaginatorIntl();
    if (lang == 'English') {
        customPaginatorIntl.itemsPerPageLabel = 'Items Per Page:';
        customPaginatorIntl.nextPageLabel = 'Next Page';
        customPaginatorIntl.previousPageLabel = 'Previous Page';
    }
    else if (lang == 'Korean') {
        customPaginatorIntl.itemsPerPageLabel = '페이지 당 아이템:';
        customPaginatorIntl.nextPageLabel = '다음 페이지';
        customPaginatorIntl.previousPageLabel = '이전 페이지';
    }
    else if (lang == 'Japanese') {
        customPaginatorIntl.itemsPerPageLabel = '1ページ当たりのアイテム数:';
        customPaginatorIntl.nextPageLabel = '次のページ';
        customPaginatorIntl.previousPageLabel = '前のページ';
    }
    else {
        customPaginatorIntl.itemsPerPageLabel = '';
        customPaginatorIntl.nextPageLabel = '';
        customPaginatorIntl.previousPageLabel = '';
    }
    return customPaginatorIntl;
}